import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { EventCard, ArticleCard } from "@/components/wei/Cards";
import { SectionHeading, Skeleton } from "@/components/wei/Section";

export function EventsSection() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/events", { params: { limit: 4 } }).then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <section data-testid="events-section" className="bg-ink">
      <div className="container-wei py-12">
        <SectionHeading title="Upcoming Events" to="/events" light id="events" />
        <div className="flex md:grid md:grid-cols-4 gap-4 overflow-x-auto no-scrollbar snap-x">
          {(items || Array(4).fill(null)).map((e, i) => e ? <div key={e.slug} className="min-w-[260px] md:min-w-0 snap-start"><EventCard e={e} /></div> : <Skeleton key={i} className="min-w-[260px] h-64 bg-white/10" />)}
        </div>
      </div>
    </section>
  );
}

export function Editorial() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/articles", { params: { limit: 4 } }).then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const feature = items?.find((a) => a.featured) || items?.[0];
  const rest = items?.filter((a) => a.slug !== feature?.slug).slice(0, 3) || [];
  return (
    <section data-testid="editorial-section" className="container-wei py-12">
      <SectionHeading title="Latest from WEI" to="/news" id="latest" />
      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-8">
        {feature ? <ArticleCard a={feature} large /> : <Skeleton className="h-[380px]" />}
        <div className="flex flex-col justify-between gap-6">{rest.length ? rest.map((a) => <ArticleCard key={a.slug} a={a} />) : [0, 1, 2].map((i) => <Skeleton key={i} className="h-20" />)}</div>
      </div>
    </section>
  );
}
